import { render, staticRenderFns } from "./Pins4Tag.vue?vue&type=template&id=76bf12e0&scoped=true&"
import script from "./Pins4Tag.vue?vue&type=script&lang=js&"
export * from "./Pins4Tag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76bf12e0",
  null
  
)

export default component.exports